<template>
  <div class="teacher-schedule-container">
    <Forbidden v-if="getUserRole[getUserRole.length - 1].role_id == 0" routerPath="notLogin" />
    <Forbidden v-else-if="getUserRole[0].role_id != userRole.TEACHER" routerPath="incorrectRole" />
    <Forbidden
      v-else-if="!getSchedulePeriodOpened && !getClassPeriodOpened"
      routerPath="notInPeriod"
    />
    <section v-else class="teacher-schedule-container vector-background">
      <b-container>
        <b-alert :show="this.success" dismissible fade variant="success">Berhasil melakukan aksi !</b-alert>
        <b-row align-h="center">
          <b-col sm="12" md="8">
            <h3 class="header-title">Pilih Jadwal Setoran</h3>
            <b-calendar
              block
              hide-header
              :date-disabled-fn="dateDisabled"
              class="calendar"
              :initial-date="dateMin._d"
              v-model="selectedDate"
              @click.native="addSelectedDate"
              locale="en"
            ></b-calendar>
            <div class="note-container">
              <div class="indicator-container" v-for="(data, index) in indicators" :key="index">
                <div class="indicator" :class="data.indicator"></div>
                <p class="note">{{ data.note }}</p>
              </div>
            </div>
          </b-col>
          <b-col sm="12" md="4">
            <div class="detail-pilihan-container">
              <h3 class="header-title">Detail Pilihan</h3>
              <p class="no-date" v-if="listSelectedDate.length == 0">Kamu belum memilih jadwal</p>
              <div class="detail-pilihan-wrapper">
                <div
                  class="detail-pilihan-card"
                  v-for="(data, index) in listSelectedDate"
                  :key="index"
                >
                  <div class="selected-date">
                    <p class="date">{{ changeDatetimeToLocaleDate(data.start_datetime) }}</p>
                  </div>
                  <div class="detail-wrapper">
                    <p>Waktu setoran:</p>
                    <p class="time">
                      {{ changeDatetimeToTime(data.start_datetime) }} -
                      {{ changeDatetimeToTime(data.end_datetime) }}
                    </p>
                  </div>
                  <div class="student-container">
                    <p class="label">Peserta:</p>
                    <p class="student" v-if="data.student != null">
                      <strong>{{ data.student.full_name }}</strong>
                    </p>
                    <p class="student" v-else>Tidak ada peserta terdaftar.</p>
                  </div>
                  <button class="detail btn" @click="detailClass(data)">Detail</button>
                </div>
              </div>
              <router-link v-if="listSelectedDate.length != 0" to="/">
                <button class="submit btn primary">Selanjutnya</button>
              </router-link>
            </div>
          </b-col>
        </b-row>
        <b-modal
          v-model="isModal"
          class="modal"
          size="sm"
          hide-footer
          centered
          no-close-on-backdrop
          header-class="no-header"
        >
          <div class="custom-modal-header">
            <h4 class="header-title">Detail Pilihan</h4>
            <div class="close" @click="cancel">×</div>
          </div>
          <div class="modal-content">
            <b-form>
              <b-row>
                <b-col>
                  <label for="selectedDate">Tanggal</label>
                  <b-form-datepicker
                    id="example-datepicker"
                    v-model="selectedDate"
                    hide-header
                    :date-disabled-fn="dateDisabled"
                    class="mb-2"
                  ></b-form-datepicker>
                  <label for="startTime">Waktu mulai</label>
                  <b-input-group>
                    <b-form-input
                      id="startTime"
                      v-model="form.start_datetime"
                      type="time"
                      placeholder="HH:mm"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-timepicker
                        v-model="form.start_datetime"
                        button-only
                        left
                        dropright
                        locale="en"
                      ></b-form-timepicker>
                    </b-input-group-append>
                  </b-input-group>
                  <label for="startTime">Waktu berakhir</label>
                  <b-input-group>
                    <b-form-input
                      id="endTime"
                      v-model="form.end_datetime"
                      type="time"
                      placeholder="HH:mm"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-timepicker
                        v-model="form.end_datetime"
                        button-variant="secondary"
                        button-only
                        left
                        dropright
                        locale="en"
                      ></b-form-timepicker>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <div class="modal-footer" v-if="editModal">
            <button v-b-modal.konfirmasi-hapus class="btn danger">Hapus</button>
            <button @click="editClass" class="btn primary">Ubah</button>
          </div>
          <div class="modal-footer" v-else>
            <button @click="cancel" class="btn">Batal</button>
            <button @click="addClass" class="btn primary">Tambah</button>
          </div>
          <b-modal id="konfirmasi-hapus" size="sm" hide-footer title="Konfirmasi untuk menghapus">
            <p class="my-2">Apakah anda yakin untuk menghapus jadwal ini ?</p>
            <div class="modal-footer">
              <button @click="cancel" class="btn">Batal</button>
              <b-button @click="deleteClass" class="btn danger">Hapus</b-button>
            </div>
          </b-modal>
        </b-modal>
      </b-container>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import User from "@/services/User";
import Forbidden from "@/views/Forbidden.vue";
import moment from "moment/moment";
import store from "@/store";
import { UserRole } from "@/services/StatusCode";

export default {
  name: "TeacherSchedule",
  components: {
    Forbidden
  },
  data() {
    return {
      dateMin: moment(store.getters.getPeriodStart("class")),
      dateMax: moment(store.getters.getPeriodEnd("class")),
      selectedDate: "",
      form: {},
      success: false,
      listSelectedDate: [],
      availableDate: {},
      isModal: false,
      editModal: false,
      indicators: [
        { indicator: "primary", note: "Belum ada peserta" },
        { indicator: "secondary", note: "Ada peserta" }
      ],
      userRole: UserRole
    };
  },
  methods: {
    addClass() {
      const startTime = moment(
        this.selectedDate + " " + this.form.start_datetime
      );
      const endTime = moment(this.selectedDate + " " + this.form.end_datetime);
      if (startTime.isSameOrAfter(endTime)) {
        store.dispatch("showAlertError", {
          title: "Gagal melakukan aksi",
          message:
            "Waktu mulai tidak boleh sama atau melebihi waktu akhir sesi !"
        });
        return;
      }
      User.sendTeacherSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName,
        startTime.format("YYYY-MM-DDTHH:mm"),
        endTime.format("YYYY-MM-DDTHH:mm")
      )
        .then(() => {
          this.success = true;
          this.getTeacherSchedule();
        })
        .finally(() => {
          this.resetModal();
        });
    },
    deleteClass() {
      User.deleteTeacherSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.form.id
      )
        .then(() => {
          this.success = true;
          this.getTeacherSchedule();
        })
        .finally(() => {
          this.resetModal();
        });
    },
    editClass() {
      const startTime = moment(
        this.selectedDate + " " + this.form.start_datetime
      );
      const endTime = moment(this.selectedDate + " " + this.form.end_datetime);
      if (startTime.isSameOrAfter(endTime)) {
        store.dispatch("showAlertError", {
          title: "Gagal melakukan aksi",
          message:
            "Waktu mulai tidak boleh sama atau melebihi waktu akhir sesi !"
        });
        return;
      }
      User.updateTeacherSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.form.id,
        startTime.format("YYYY-MM-DDTHH:mm"),
        endTime.format("YYYY-MM-DDTHH:mm")
      )
        .then(() => {
          this.success = true;
          this.getTeacherSchedule();
        })
        .finally(() => {
          this.resetModal();
        });
    },
    detailClass(data) {
      this.selectedDate = this.changeDatetimeToDate(data.start_datetime);
      if (
        moment().isSameOrAfter(
          moment(this.selectedDate).subtract(1, "day"),
          "day"
        )
      ) {
        store.dispatch("showAlertError", {
          title: "Gagal melakukan aksi",
          message:
            "Sesi jadwal yang diubah atau ditambah hanya dalam waktu 2 hari ke depan."
        });
        this.selectedDate = "";
        return;
      }
      this.form = { ...data };
      this.form["start_datetime"] = this.changeDatetimeToTime(
        data.start_datetime
      );
      this.form["end_datetime"] = this.changeDatetimeToTime(data.end_datetime);
      this.isModal = true;
      this.editModal = true;
    },
    addSelectedDate() {
      if (this.selectedDate != "") {
        if (
          moment().isSameOrAfter(
            moment(this.selectedDate).subtract(1, "day"),
            "day"
          )
        ) {
          store.dispatch("showAlertError", {
            title: "Gagal melakukan aksi",
            message:
              "Sesi jadwal yang diubah atau ditambah hanya dalam waktu 2 hari ke depan."
          });
          this.selectedDate = "";
          return;
        }
        this.isModal = true;
      } else {
        this.printAvailableDate();
      }
    },
    printAvailableDate() {
      document
        .querySelectorAll("div.b-calendar-grid-body div[role='button']")
        .forEach(btn => {
          btn.classList.remove("available");
          btn.classList.remove("halfAvailable");
        });
      this.listSelectedDate.forEach(data => {
        const date = document.querySelector(
          "div[data-date='" +
            this.changeDatetimeToDate(data.start_datetime) +
            "']"
        );
        if (date != null) {
          if (data.student == null) {
            if (date.classList.contains("halfAvailable")) {
              date.classList.replace("halfAvailable", "available");
            } else {
              date.classList.add("available");
            }
          } else {
            if (date.classList.contains("available")) {
              date.classList.replace("available", "halfAvailable");
            } else {
              date.classList.add("halfAvailable");
            }
          }
        }
      });
    },
    async getTeacherSchedule() {
      await User.getTeacherSchedule(
        process.env.VUE_APP_URL,
        this.getAccessToken,
        this.getTermName
      ).then(response => {
        const listSelectedDate = response.filter(data => {
          const sessionStart = moment(data.start_datetime);
          return (
            sessionStart.isSameOrAfter(this.dateMin, "day") &&
            sessionStart.isSameOrBefore(this.dateMax, "day")
          );
        });
        this.listSelectedDate = listSelectedDate;
        this.printAvailableDate();
      });
    },
    cancel() {
      this.resetModal();
      this.printAvailableDate();
    },
    resetModal() {
      this.isModal = false;
      this.editModal = false;
      this.form = {};
      this.selectedDate = "";
    },
    dateDisabled(ymd, date) {
      const today = moment().add(1, "day");
      return (
        date <= today._d || date < this.dateMin._d || date > this.dateMax._d
      );
    },
    async initData() {
      await this.getTeacherSchedule();
    },
    changeDatetimeToTime(datetime) {
      const date = moment(datetime);
      date.locale("id");
      return date.format("HH:mm");
    },
    changeDatetimeToDate(datetime) {
      const date = moment(datetime);
      date.locale("id");
      return date.format("YYYY-MM-DD");
    },
    changeDatetimeToLocaleDate(datetime) {
      const date = moment(datetime);
      date.locale("id");
      return date.format("DD MMMM YYYY");
    }
  },
  created() {
    User.getLatestPeriod(process.env.VUE_APP_URL);
    User.getPeriods(process.env.VUE_APP_URL, this.getTermName);
    if (
      this.getUserRole[this.getUserRole.length - 1].role_id != 0 &&
      this.getUserRole[0].role_id == UserRole.TEACHER &&
      (this.getSchedulePeriodOpened || this.getClassPeriodOpened)
    ) {
      this.initData();
    }
  },
  computed: {
    ...mapGetters({
      getTermName: "getTermName",
      getAccessToken: "getAccessToken",
      getUserRole: "getUserRole",
      getUsername: "getUsername",
      getFullname: "getFullname",
      getFirstname: "getFirstname",
      getLastName: "getLastname",
      getSchedulePeriodOpened: "getSchedulePeriodOpened",
      getClassPeriodOpened: "getClassPeriodOpened"
    })
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/form.scss";

.btn {
  margin-left: $gap-sm-2;
}

.note-container {
  display: flex;
  flex-direction: column;
  margin-bottom: $gap-m-2;

  .indicator-container {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;

    .indicator {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 0 $gap-sm-2;

      &.primary {
        background: $primary;
      }

      &.secondary {
        background: $secondary;
      }

      &.danger {
        background: $danger;
      }
    }
  }
}

.teacher-schedule-container {
  min-height: inherit;

  .header-title {
    font-weight: bold;
    margin: $gap-m-1 0;
  }

  .container {
    min-height: inherit;
    padding-top: $gap-m-2;
  }

  b-row {
    min-height: inherit;
  }

  b-col {
    min-height: inherit;
  }

  .detail-pilihan-container {
    padding: $gap-m-1;
    box-shadow: 0 0 6px rgba($color: #aaa, $alpha: 0.12);
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    .detail-pilihan-wrapper {
      padding: 0 $gap-sm-2;
      border-radius: 20px;
      overflow-y: auto;
      max-height: 600px;
      scrollbar-width: 0;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .no-date {
      text-align: center;
      margin: $gap-m-2 0;
    }

    .submit {
      margin: $gap-m-1 0 $gap-sm-2 0;
      align-self: flex-end;
    }

    .detail-pilihan-card {
      box-shadow: 0 0 6px rgba($color: #aaa, $alpha: 0.12);
      padding: $gap-m-1;
      border-radius: 10px;
      margin: $gap-m-2 0;
      display: flex;
      flex-direction: column;

      .detail-wrapper {
        margin-bottom: $gap-sm-2;

        .time {
          font-weight: 600;
        }
      }

      button.detail {
        align-self: flex-end;
      }
    }
  }
}

.selected-date {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: $gap-m-1;

  p {
    padding: $gap-sm-1 $gap-sm-2;
    background: $primary;
    color: $white;
    border-radius: 10px;
  }
}
</style>
